import { useState } from 'react';
import { X, Mail, Lock } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { login } from '../lib/api';
import { toast } from 'sonner';

export const AuthModal = ({ isOpen, onClose, onLogin }) => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const result = await login(formData.email, formData.password);
      
      // Server sets httpOnly cookie automatically — DO NOT store token in localStorage.
      // Only store non-sensitive user identity for UI rendering.
      localStorage.setItem('user', JSON.stringify(result.user));
      
      // Dispatch custom event for navbar to update
      window.dispatchEvent(new CustomEvent('user-login', { detail: result.user }));
      
      if (onLogin) {
        onLogin(result.user);
      }
      
      toast.success('Bine ai venit!');
      
      // Reset form
      setFormData({ email: '', password: '' });
      onClose();
      
      // Redirect operators to their dashboard
      if (result.user?.role === 'operator') {
        window.location.href = '/operator';
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || 'A apărut o eroare');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4" data-testid="auth-modal">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-navy/80 backdrop-blur-sm"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative glass rounded-2xl p-8 w-full max-w-md animate-slide-up">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-white/60 hover:text-white"
          data-testid="close-auth-modal"
        >
          <X className="w-5 h-5" />
        </button>

        <h2 className="font-heading font-bold text-2xl text-white mb-2">
          Autentificare
        </h2>
        <p className="text-white/60 mb-6">
          Intră în contul tău VaAi
        </p>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="relative">
            <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
            <Input
              type="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              className="pl-10 bg-white/5 border-white/20 text-white placeholder:text-white/40"
              required
              data-testid="auth-email-input"
            />
          </div>

          <div className="relative">
            <Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/40" />
            <Input
              type="password"
              placeholder="Parolă"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              className="pl-10 bg-white/5 border-white/20 text-white placeholder:text-white/40"
              required
              data-testid="auth-password-input"
            />
          </div>

          <Button
            type="submit"
            disabled={loading}
            className="w-full btn-gold py-3"
            data-testid="auth-submit-btn"
          >
            {loading ? 'Se procesează...' : 'Autentificare'}
          </Button>
        </form>
      </div>
    </div>
  );
};
